<!--@format-->
<template>
    <div class="document-widget">
        <div class="widget-header">
            <h3>Upload PDF</h3>
            <div class="svg-container widget-close-button" @click="closeWidget">
                <widget-close-svg />
            </div>
        </div>
        <loading-card :is-loading="isLoading" />
        <div v-if="!isLoading" class="content-wrapper">
            <div class="widget-container">
                <document-upload-pdf-step
                    :list-pdf-pages="pdfImagePages"
                    @get-pdf="handlePdf"
                    @get-pdf-collateral="handlePdfCollateral"
                />
            </div>
        </div>
        <div class="widget-footer">
            <div class="actions-container">
                <app-button class="transparent-btn" @click="closeWidget"> Cancel </app-button>
            </div>
            <div class="actions-container" @click="injectPagesFromPdf">
                <app-button> Add </app-button>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');
const DocumentUploadPdfStep = () =>
    import('@/components/sliding-widgets/document/steps/document-upload-pdf-step.vue');
const LoadingCard = () => import('@/components/common/loading-card');

import EventBus from '@/scripts/event-bus';
import { DocumentService } from '@/scripts/services/document/document-service';
import DocumentBuilderMixin from '@/mixins/builder/document-builder-mixin';

export default {
    name: 'document-upload-pdf-widget',

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'loading-card': LoadingCard,
        'document-upload-pdf-step': DocumentUploadPdfStep,
    },

    mixins: [DocumentBuilderMixin],

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            isLoading: false,
            pdfImagePages: [],
        };
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        handlePdf(pdfFile) {
            this.isLoading = true;

            const fd = this.createFormForPdfFile(pdfFile);
            DocumentService.postPdfFormData(fd)
                .then(({ data }) => {
                    let actualLength = this.pdfImagePages.length;
                    data.data.forEach((img, index) => {
                        this.pdfImagePages.push({
                            id: actualLength + (index + 1),
                            img: img,
                            selected: true,
                            order: actualLength + (index + 1),
                        });
                    });
                })
                .catch((error) => {
                    this.$helpers.showFailNotification(
                        'An error ocurred while trying to upload your pdf.',
                        { error },
                    );
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        handlePdfCollateral(urlPdf) {
            this.isLoading = true;

            const payload = {
                url: urlPdf,
            };

            DocumentService.postPdfFromCollateral(payload)
                .then(({ data }) => {
                    let actualLength = this.pdfImagePages.length;
                    data.data.forEach((img, index) => {
                        this.pdfImagePages.push({
                            id: actualLength + (index + 1),
                            img: img,
                            selected: true,
                            order: actualLength + (index + 1),
                        });
                    });
                })
                .catch((error) => {
                    this.$helpers.showFailNotification(
                        'An error ocurred while trying to get your pdf.',
                        { error },
                    );
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        injectPagesFromPdf() {
            EventBus.$emit(
                'document:inject-pdf-pages',
                this.pdfImagePages,
                this.widget.options.position,
            );
            this.closeWidget();
        },
    },
};
</script>

<style>
.document-widget.widget .content-wrapper {
    padding: 40px 24px;
}

.document-widget .starting-step .app-input-radio.horizontal .option-image {
    height: 157px;
    width: 258px;
}

.document-widget .widget-footer .transparent-btn {
    background: transparent;
    border: 1px solid #cac6cb;
    color: #382153;
}

.document-widget .widget-footer .transparent-btn:hover {
    background: #e1e0e5;
}

.document-widget .widget-footer .actions-container {
    display: flex;
    justify-content: space-between;
}

.document-widget .widget-footer.existing-template .actions-container {
    width: 100%;
}

.document-widget .widget-footer.existing-template .add-button-container {
    align-items: center;
    display: flex;
    gap: 15px;
}

.document-widget .widget-footer.existing-template .add-btn {
    padding: 0 40px;
}

.document-widget .widget-footer .secondary-btn {
    background: transparent;
    border: 1px solid#18aeff;
    color: #18aeff;
    margin-right: 14px;
}

.document-widget .widget-footer .secondary-btn:hover {
    background: #dbedfa;
}
</style>
